/* eslint-disable no-console */
/* eslint-disable max-len */
import { API } from 'aws-amplify';

function init()
{
	throw new Error('Function not implemented.');
}

export function createRoom(body:any)
{
	return API.post('ssoChat', '/room', { body });
}

export function createChat(body:any)
{
	return API.post('ssoChat', '/chat', { body });
}

export function updateChat(body:any)
{
	return API.put('ssoChat', '/chat', { body });
}

export function getContacts(type: any, search: any, limit: any, skip: any, queryparams, filter = 'All', check = '')
{
	const params = { type, search, limit, skip, filter, check };

	// Remove any key-value pairs where the value is empty or null
	Object.keys(params).forEach((key) =>
	{
		if (params[key] === '' || params[key] === null || params[key] === undefined)
		{
			delete params[key];
		}
	});

	// Convert the remaining parameters into a query string
	const queryString = Object.keys(params)?.map((key) => `${key}=${params[key]}`)
		?.join('&');

	// Add any additional query params
	const finalQuery = queryString ? `${queryString}&${queryparams}` : queryparams;

	return API.get('ssoChat', `/getContacts?${finalQuery}`, init);
}

export function getContactsCount(type: any, search: any, queryParamRes:any, filter = 'All', check = '')
{
	return API.get('ssoChat', `/getContacts?type=${type}&search=${search}&filter=${filter}&check=${check}${queryParamRes}&count=true`, init);
}

export function getRoomMembers(roomId: any, type = 'addParticipants', search: any, limit: any, skip: any, queryparams:any)
{
	return API.get('ssoChat', `/getRoomMembers/${roomId}?type=${type}&searchKey=${search}&limit=${limit}&skip=${skip}${queryparams}`, init);
}

export function getRoomMembersCount(roomId: any, type = 'addParticipants', search: any, queryParamRes:any)
{
	return API.get('ssoChat', `/getRoomMembers/${roomId}?type=${type}&searchKey=${search}&count=true${queryParamRes}`, init);
}

export function getChatByRoomId(roomType: any, query: any)
{
	return API.get('ssoChat', `/getChatData/${roomType}?${query}`, init);
}

export function getRooms(roomType: any, searchKey: any, limit:any, skip:any, queryparams:any, active = false)
{
	return API.get('ssoChat', `/room?roomType=${roomType}&searchKey=${searchKey}&limit=${limit}&skip=${skip}${queryparams}&active=${active}`, init);
}

export function getRoomsCount(roomType: any, searchKey: any, queryparams:any, active = false)
{
	return API.get('ssoChat', `/room?roomType=${roomType}&searchKey=${searchKey}&active=${active}&count=true${queryparams}`, init);
}

export function getRoomDetails(roomId: any, queryparams:any)
{
	return API.get('ssoChat', `/groupDetailsByRoomId/${roomId}${queryparams}`, init);
}

export function getRoomMembersForGroup(roomId: any, queryparams:any)
{
	return API.get('ssoChat', `/getRoomMembers/${roomId}${queryparams}`, init);
}

export function starChat(query: any)
{
	return API.get('ssoChat', `/media${query}`, init);
}

export function chatUnreadCount()
{
	return API.get('ssoChat', '/chatUnreadCount', init);
}

export function forwardMessageData(body: any)
{
	return API.post('ssoChat', '/forward', { body });
}
export function updateRoomData(body: any, path:any)
{
	return API.put('ssoChat', `/room/${path}`, { body });
}

export function getReminders(query:any)
{
	return API.get('ssoChat', `/reminder/${query}`, init);
}

export function deleteReminders(path:any, query:any, body?:any)
{
	return API.del('ssoChat', `/reminder/${path}${query}`, { body });
}

export function createReminders(body:any, query:any)
{
	return API.post('ssoChat', `/reminder${query}`, { body });
}
export function getReminderById(query:any)
{
	return API.get('ssoChat', `/getReminderById${query}`, init);
}

export function updateReminders(body:any, query:any)
{
	return API.put('ssoChat', `/reminder${query}`, { body });
}